<script>
  import { afterUpdate, onMount } from "svelte"
  import notify from "../../../../../../Script/notify"
  import bulkJson from "../../../Stores/jsonBulkData"
  import { createEventDispatcher } from "svelte"
  import { releaseSelectedDocument } from "../../../Script/bulkUpload"
  import Loader from "../../../../../../Shared/Slots/loader.svelte"
  const dispatch = createEventDispatcher()

  /**
   * @type {import("../../../Script/document".bulkDocument)}
   */
  export let document
  /**
   * @type {boolean} whether to disable release btn or not during document release
   */
  export let disableReleaseBtn
  /**
   * @type {string} the text to be shown in the card
   */
  let cardText
  /**
   * @type {string} The card color (hex code) used for styling elements.
   */
  let cardColor
  /**
   * @type {string} The text color (hex code) used for styling elements.
   */
  let textColor
  /**
   * @type {string} name of the icon to be shown in the cards
   */
  let iconName
  /**
   * @type {boolean} whether to show loading screen or not
   */
  let showLoading = false

  onMount(() => {
    changeColorAndText()
  })
  afterUpdate(() => {
    changeColorAndText()
  })

  /**
   * Change the card color, text, and icon based on the document's status.
   * This function updates the visual representation of a document card.
   */
  const changeColorAndText = () => {
    // Check if the document is marked as failed
    if (document.isDocumentFailed) {
      // Set card color and text for a failed document
      cardColor = "#f8d7da"
      textColor = "#721c24"
    } else {
      // Check if the document has a fileHash
      if (!document.fileHash) {
        // if (typeof document.filename == "object")
        // Check if the filename is of type string
        if (typeof document.filename.filename == "string") {
          // Set card text to indicate waiting for a specific file
          cardText = `Waiting for File <strong>${document.filename.filename}</strong>`
          cardColor = "#F9E0C2"
          textColor = "#EA9633"
          iconName = "triangle-exclamation"
        } else {
          // Set card text to indicate uploading a document
          cardText = "Uploading Document..."
          cardColor = "#CCEAE8"
          textColor = "#1F51FF"
          iconName = "file"
        }
        return
      } else {
        // Set card text to indicate a successfully uploaded document
        cardText = `Document of <strong>${document.recName}</strong> Uploaded.`
        cardColor = "#C2FFE9"
        textColor = "#005620"
        iconName = "check"
        return
      }
    }
  }

  /**
   * Function for releasig the document
   */
  const releaseDocument = async () => {
    try {
      // Set showLoading and disableReleaseBtn to true to indicate loading state
      showLoading = true
      disableReleaseBtn = true

      // Call the releaseSelectedDocument function with document.id
      await releaseSelectedDocument(document.id)

      // Get the receiver's name from document
      let receiver = document.recName

      // Remove the released document from the $bulkJson array
      $bulkJson = $bulkJson.filter((a) => a.id != document.id)

      // Display a success notification indicating the successful release
      notify.success(`Document of <strong>${receiver}</strong> released Successfully`)

      // Dispatch an event named "release"
      dispatch("release")
    } catch (error) {
      const info = "PAGE: Upload Flow (Bulk Upload)\nEVENT: While releasing document"
      notify.danger(error, info)
    } finally {
      // Set showLoading and disableReleaseBtn back to false to end the loading state
      showLoading = false
      disableReleaseBtn = false
    }
  }
</script>

<div style="background: {cardColor};color: {textColor}" class="relative flex w-full items-center gap-3 rounded-md px-2 py-3 text-base font-medium">
  {#if !document.isDocumentFailed}
    <div style="background: {textColor}" class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full text-lg text-white">
      <i class="fa-solid fa-{iconName}" />
    </div>
    <h1 class="w-3/5 truncate text-base font-medium">{@html cardText}</h1>
  {:else}
    {#if showLoading}
      <Loader>
        <span class="flex">
          {@html "Releasing Document&nbsp;&nbsp;"}
        </span>
      </Loader>
    {/if}
    <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-red-500 text-lg text-white">
      <i class="fa-solid fa-triangle-exclamation" />
    </div>

    <div class="flex w-2/5 items-center gap-3 text-base font-medium">
      <h1 class="truncate">
        Document of <strong class="text-[#491217]">{document.recName}</strong>
        failed
      </h1>
      <button data-tooltip={document.errorMsg} tooltip-position="top">
        <i class="fa-solid fa-circle-info fa-lg text-[#491217]" />
      </button>
    </div>

    <div class="ml-auto flex gap-6 md:gap-3">
      <button type="button" on:click={releaseDocument} class="flex items-center rounded-md border border-red-500 px-4 py-1">
        <span>
          <i class="fa-solid fa-trash-can" />
        </span>
        <span class="hidden text-sm font-bold mobile:block">&nbsp;&nbsp;Release&nbsp;Document&nbsp;</span>
      </button>
    </div>
  {/if}
</div>
